<h1 tabindex="-1" class="dsd-t-3">{{ 'caad.accueil.titreServiceCarteCredit' | translate }}</h1>
<p>{{ 'caad.accueil.description' | translate }}</p>
<dsd-container>
  <h2 class="dsd-t-4">{{ 'caad.accueil.vosComptes.titre' | translate }}</h2>
  <ng-container
    *ngIf="
      templateAffichageAdresseBancaire === templateCoordonneesBancaireEnum.AFFICHER_COORDONNEES_BANCAIRE;
      then afficherCoordonnees;
      else afficherErreur
    "></ng-container>

  <ng-template #afficherCoordonnees>
    <dsd-grid-row>
      <dsd-grid-col class="dsd-mb-0" sm-col="12" md-col="6" lg-col="4">
        <app-info-profil-caisse-folio [profilCaisseFolio]="infoProfilCaisseFolio"></app-info-profil-caisse-folio>
      </dsd-grid-col>
    </dsd-grid-row>
    <p>
      <span class="libelle">{{ libelleAdresseCourante | translate }}&nbsp;</span>
      <span class="valeur line-adresse">{{ adresse | adresse }}</span>
    </p>
    <dsd-grid-row *ngIf="doitAfficherAdressePostdatee()">
      <dsd-grid-col class="dsd-mb-0" sm-col="12" md-col="6" lg-col="4">
        <dsd-container
          border-color="dsd-color-font-decorative-graphite-200"
          border-width="double"
          border-radius="sm"
          padding="sm"
          margin="sm">
          <p>
            <span class="libelle"
              >{{ 'caad.accueil.vosComptes.libelle.adresse' | translate }}
              {{ 'caad.accueil.libelle.au' | translate }}
              <span [innerHTML]="adressePostdatee.dateDebutUtilisation | dateCustom"></span>&nbsp;</span
            >
            <span class="valeur line-adresse">{{ adressePostdatee | adresse }}</span>
          </p>
          <dsd-button
            variant="compact"
            full-width="xs"
            theme="red"
            (dsdButtonClick)="afficherModaleSupressionAdressePostdatee()">
            {{ 'caad.button.supprimer' | translate }}
          </dsd-button>
        </dsd-container>
      </dsd-grid-col>
    </dsd-grid-row>
    <dsd-alert id="confirmationSupression" variant="confirmation" *ngIf="postdateeSupprimee" tabindex="-1">
      <h2 slot="title">Confirmation</h2>
      <p>{{ 'caad.accueil.libelle.horsEcran.postdateeSupprimee' | translate }}</p>
    </dsd-alert>
    <p *ngIf="courriel">
      <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.courriel' | translate }}&nbsp;</span>
      <span class="valeur">{{ courriel }}</span>
    </p>
    <p *ngIf="telephonePrincipal">
      <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.telephone' | translate }}&nbsp;</span>
      <span class="valeur">{{ telephonePrincipal | phone }}</span>
    </p>
    <p *ngIf="telephoneSecondaire">
      <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.telephoneSecondaire' | translate }}&nbsp;</span>
      <span class="valeur">{{ telephoneSecondaire | phone }}</span>
    </p>
    <p *ngIf="telephoneTravail">
      <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.telephoneTravail' | translate }}&nbsp;</span>
      <span class="valeur">
        {{ telephoneTravail | phone }}
      </span>
    </p>

    <dsd-button variant="primary" id="allerAModification" full-width="xs" (dsdButtonClick)="allerAModification()">
      {{ 'caad.button.modifier' | translate }}
      <span class="dsd-sr-only">  {{ 'caad.accueil.vosComptes.horsEcran.boutonModifier' | translate }} </span>
    </dsd-button>
  </ng-template>

  <ng-template #afficherErreur>
    <ng-container
      *ngIf="
        templateAffichageAdresseBancaire === templateCoordonneesBancaireEnum.ERREUR_NON_DISPONIBLE_MEMBRE;
        then afficherBancaireNonDisponiblePourMembre;
        else afficherBancaireNonDisponible
      "></ng-container>
  </ng-template>
  <ng-template #afficherBancaireNonDisponiblePourMembre>
    <dsd-alert variant="inactive" class="dsd-mb-sm">
      <h3 slot="title">{{ 'caad.accueil.alerte.horsEcran.erreur' | translate }}</h3>
      {{ 'caad.accueil.vosComptes.nonDisponiblePourMembre.alerte.bancaireNonDisponiblePourMembre' | translate }}
    </dsd-alert>
    <p>{{ 'caad.accueil.vosComptes.nonDisponiblePourMembre.contactezNous' | translate }}</p>
    <dsd-link-action type="external" customSrOnly="{{'caad.accueil.vosComptes.nonDisponiblePourMembre.horsEcran.link' | translate}}">
      <a href="{{ getUrlPlanifierAppel() }}" id="planifierAppelErreur" (click)="onClickPlanifierAppelErreur()">{{
        'caad.accueil.autresComptes.link' | translate
      }}</a>
    </dsd-link-action>
  </ng-template>
  <ng-template #afficherBancaireNonDisponible>
    <dsd-alert variant="inactive" class="dsd-m-0">
      <h3 slot="title">{{ 'caad.accueil.alerte.horsEcran.erreur' | translate }}</h3>
      {{ 'caad.accueil.vosComptes.nonDisponible.alerte.bancaireNonDisponible' | translate }}
    </dsd-alert>
  </ng-template>
</dsd-container>

<!-- Pour vos autres comptes -->
<dsd-container *ngIf="adressesSpecifiques?.length > 0">
  <h2 class="dsd-t-4">{{ 'caad.accueil.autresComptes.titre' | translate }}</h2>

  <ng-container *ngFor="let compte of adressesSpecifiques; let last = last">
    <dsd-grid-row>
      <dsd-grid-col class="dsd-mb-0" sm-col="12" md-col="6" lg-col="4">
        <app-info-profil-caisse-folio
          [profilCaisseFolio]="compte.profilsCaisse"
          [autresCompte]="true"></app-info-profil-caisse-folio>
      </dsd-grid-col>
    </dsd-grid-row>
    <p>
      <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.adresse' | translate }}&nbsp;</span>
      <span class="valeur line-adresse">{{ compte | adresse }}</span>
    </p>
    <div *ngIf="!last" class="dsd-hr dsd-hr-deco"></div>
  </ng-container>

  <p>{{ 'caad.accueil.autresComptes.description' | translate }}</p>
  <dsd-link-action type="external" customSrOnly="{{'caad.accueil.autresComptes.horsEcran.link' | translate}}">
    <a href="{{ getUrlPlanifierAppel() }}" id="planifierAppel" (click)="onClickPlanifierAppel()">{{
      'caad.accueil.autresComptes.link' | translate
    }}</a>
  </dsd-link-action>
</dsd-container>

<dsd-container>
  <h2 class="dsd-t-4">{{ 'caad.accueil.credit.titre' | translate }}</h2>
  <dsd-alert variant="info" class="dsd-mb-sm">
    <h3 slot="title">{{ 'caad.accueil.alerte.horsEcran.information' | translate }}</h3>
    {{ 'caad.accueil.credit.alerte' | translate }}
  </dsd-alert>
  <p>{{ 'caad.accueil.credit.description' | translate }}</p>
  <dsd-link-action customSrOnly="{{'caad.accueil.credit.horsEcran.link' | translate}}">
    <a
      [routerLink]="[lienCredit]"
      [queryParamsHandling]="lienCreditQueryParamsHandling"
      (click)="onClickCoordonneesCredit()"
      id="coordonneesCredit"
      >{{ 'caad.accueil.credit.link' | translate }}</a
    >
  </dsd-link-action>
</dsd-container>

<dsd-container>
  <h2 class="dsd-t-4">{{ 'caad.accueil.autresProduits.titre' | translate }}</h2>
  <p>{{ 'caad.accueil.autresProduits.description' | translate }}</p>
  <dsd-grid class="dsd-d-none sm:dsd-d-block">
    <dsd-grid-row>
      <dsd-grid-col class="dsd-d-flex" sm-col="4">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true" class="dsd-mb-0">
          <a
            slot="link"
            id="assurance"
            [href]="'caad.accueil.autresProduits.assurances.url' | translate"
            (click)="onClickAutreProduit('desjardins assurance')"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.assurances.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.assurances.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
      <dsd-grid-col class="dsd-d-flex" sm-col="4">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true" class="dsd-mb-0">
          <a
            slot="link"
            id="securitefinanciere"
            [href]="'caad.accueil.autresProduits.securiteFinanciere.url' | translate"
            (click)="onClickAutreProduit('desjardins securite financiere')"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.securiteFinanciere.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.securiteFinanciere.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
      <dsd-grid-col class="dsd-d-flex" sm-col="4">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true" class="dsd-mb-0">
          <a
            slot="link"
            id="lapersonnelle"
            [href]="'caad.accueil.autresProduits.laPersonnelle.url' | translate"
            (click)="onClickAutreProduit('la personnelle')"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.laPersonnelle.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.laPersonnelle.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
    </dsd-grid-row>
  </dsd-grid>
  <dsd-grid class="dsd-d-block sm:dsd-d-none dsd-ml-0 dsd-mr-0" style="max-width: fit-content">
    <dsd-grid-row>
      <dsd-grid-col class="dsd-d-flex">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true">
          <a
            slot="link"
            id="assurancesm"
            [href]="'caad.accueil.autresProduits.assurances.url' | translate"
            (click)="onClickAutreProduit('desjardins assurance')"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.assurances.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.assurances.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
      <dsd-grid-col class="dsd-d-flex">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true">
          <a
            slot="link"
            id="securitefinancieresm"
            [href]="'caad.accueil.autresProduits.securiteFinanciere.url' | translate"
            (click)="onClickAutreProduit('desjardins securite financiere')"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.securiteFinanciere.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.securiteFinanciere.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
      <dsd-grid-col class="dsd-d-flex">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true" class="dsd-mb-0">
          <a
            slot="link"
            id="lapersonnellesm"
            [href]="'caad.accueil.autresProduits.laPersonnelle.url' | translate"
            (click)="onClickAutreProduit('la personnelle')"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.laPersonnelle.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.laPersonnelle.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
    </dsd-grid-row>
  </dsd-grid>
</dsd-container>

<app-bouton-retour />

<app-modale-supprimer
  variant="adresse"
  [show]="showModaleSupprimerAdresse"
  (suppressionConfirmee)="handleConfirmSuppressionAdresse()"
  (suppressionAnnulee)="handleCancelSuppressionAdresse()">
</app-modale-supprimer>
